export const environment = {
  defaultTitle: 'UPG Reward Points Admin',
  version: 'DEV 1.4.6',
  apiVersion: '1.4.3',

  baseUrl: 'https://rewardappapi.upgapp.com/',
  //baseUrl: 'http://zinmintun.upgapp.com:8080/',
  //baseUrl: 'http://localhost:8080/',
};
